import { Component, Element, Event, Host, Prop, Watch, h } from '@stencil/core';
import { checkSlottedContentForInvalidHTML, generateRandomNumber, hideFocusRingWhenUsingMouse } from '../../../../global/utils/utils';
import accessNo from '../../../../assets/agl_icon_dig_access_no_32px.svg';
import accountNo from '../../../../assets/agl_icon_dig_account_no_32px.svg';
import accountYes from '../../../../assets/agl_icon_dig_account_yes_32px.svg';
import batteryIcon from '../../../../assets/agl_icon_dig_battery_32px.svg';
import batteryNew from '../../../../assets/agl_icon_dig_battery_new_32px.svg';
import billNo from '../../../../assets/agl_icon_dig_bill_no.svg';
import billYes from '../../../../assets/agl_icon_dig_bill_yes.svg';
import business from '../../../../assets/agl_icon_dig_business.svg';
import calendar from '../../../../assets/agl_icon_dig_calendar_48px.svg';
import calendarDollar from '../../../../assets/agl_icon_dig_calendar_dollar_48px.svg';
import carbonNeutralOff from '../../../../assets/agl_icon_carbon_neutral_off_32px.svg';
import carbonNeutralOn from '../../../../assets/agl_icon_carbon_neutral_on_32px.svg';
import connected from '../../../../assets/agl_icon_dig_connection_connected.svg';
import cross from '../../../../assets/agl_icon_dig_cross_32px.svg';
import fix from '../../../../assets/agl_icon_dig_fix_32px.svg';
import fixNo from '../../../../assets/agl_icon_dig_fix_no_32px.svg';
import heartIcon from '../../../../assets/agl_icon_dig_heart_32px.svg';
import homeIcon from '../../../../assets/agl_icon_dig_home_32px.svg';
import inspectNo from '../../../../assets/agl_icon_dig_inspect_no_32px.svg';
import internetIcon from '../../../../assets/agl_icon_dig_internet_32px.svg';
import lifeSupportIcon from '../../../../assets/agl_icon_dig_life_support_32px.svg';
import lightsNormal from '../../../../assets/agl_icon_dig_lights_normal_32px.svg';
import lightsRed from '../../../../assets/agl_icon_dig_lights_red_32px.svg';
import lightsScreenError from '../../../../assets/agl_icon_dig_lights_screen_error_32px.svg';
import medicalAlarm from '../../../../assets/agl_icon_dig_medical_alarm_32px.svg';
import modemIcon from '../../../../assets/agl_icon_dig_modem_32px.svg';
import modemUseOwnIcon from '../../../../assets/agl_icon_dig_modem_use_own_32px.svg';
import movingIcon from '../../../../assets/agl_icon_dig_moving_32px.svg';
import newConnection from '../../../../assets/agl_icon_dig_connection_new.svg';
import noInternetIcon from '../../../../assets/agl_icon_dig_internet_no_32px.svg';
import nolistIcon from '../../../../assets/agl_icon_dig_listing_no_32px.svg';
import pencilIcon from '../../../../assets/agl_icon_dig_pencil_32px.svg';
import planAddIcon from '../../../../assets/agl_icon_dig_plan_add_32px.svg';
import planEditIcon from '../../../../assets/agl_icon_dig_plan_edit_32px.svg';
import questionIcon from '../../../../assets/agl_icon_dig_question_32px.svg';
import rentIcon from '../../../../assets/agl_icon_dig_rent_32px.svg';
import service from '../../../../assets/agl_icon_dig_service_32px.svg';
import serviceNo from '../../../../assets/agl_icon_dig_service_no_32px.svg';
import solar from '../../../../assets/agl_icon_dig_solar_32px.svg';
import solarBundle from '../../../../assets/agl_icon_dig_solar_bundle_32px.svg';
import solarDamage from '../../../../assets/agl_icon_dig_solar_damage_32px.svg';
import solarDirty from '../../../../assets/agl_icon_dig_solar_dirty_32px.svg';
import solarNo from '../../../../assets/agl_icon_dig_solar_no_32px.svg';
import solarShaded from '../../../../assets/agl_icon_dig_solar_shaded_32px.svg';
import solarYes from '../../../../assets/agl_icon_dig_solar_yes_32px.svg';
import switchOff from '../../../../assets/agl_icon_dig_switch_off_32px.svg';
import switchOn from '../../../../assets/agl_icon_dig_switch_on_32px.svg';
import tick from '../../../../assets/tick.svg';
import tickInCircle from '../../../../assets/agl_icon_dig_tick_in_circle_32px.svg';
import usageHigh from '../../../../assets/agl_icon_dig_usage_high_32px.svg';
import voipNo from '../../../../assets/agl_icon_dig_voip_no_32px.svg';
import voipYes from '../../../../assets/agl_icon_dig_voip_yes_32px.svg';
import supportIcon from '../../../../assets/agl_icon_dig_support_32px.svg';
import calendarIcon from '../../../../assets/agl_icon_dig_calendar_32px.svg';
import clockIcon from '../../../../assets/agl_icon_dig_clock_32px.svg';
import bellIcon from '../../../../assets/agl_icon_dig_bell_48px.svg';
import user from '../../../../assets/agl_icon_dig_user_32px.svg';
/**
 * @slot sub-heading - Used for the inclusion of Phrasing content (see https://www.w3.org/TR/2012/WD-html-markup-20121025/common-models.html) eg. an anchor tag in the sub heading
 */
export class RadioButtonComponent {
  constructor() {
    /**
     * The type of radio button to be displayed
     */
    this.type = 'basic';
    /**
     * The type of radio button to be displayed
     */
    this.size = 'large';
    /**
     * Is the radio button in a checked state or not when first displayed.
     */
    this.checked = false;
    this.radioButtonTypes = [
      'basic',
      'panel',
      'content',
      'image',
      'agl_icon_carbon_neutral_off_32px',
      'agl_icon_carbon_neutral_on_32px',
      'agl_icon_dig_account_no_32px',
      'agl_icon_dig_account_yes_32px',
      'agl_icon_dig_battery_32px',
      'agl_icon_dig_battery_new_32px',
      'agl_icon_dig_calendar_48px',
      'agl_icon_dig_calendar_dollar_48px',
      'agl_icon_dig_heart_32px',
      'agl_icon_dig_home_32px',
      'agl_icon_dig_internet_32px',
      'agl_icon_dig_internet_no_32px',
      'agl_icon_dig_life_support_32px',
      'agl_icon_dig_listing_no_32px',
      'agl_icon_dig_medical_alarm_32px',
      'agl_icon_dig_modem_32px',
      'agl_icon_dig_modem_use_own_32px',
      'agl_icon_dig_moving_32px',
      'agl_icon_dig_pencil_32px',
      'agl_icon_dig_plan_add_32px',
      'agl_icon_dig_plan_edit_32px',
      'agl_icon_dig_question_32px',
      'agl_icon_dig_rent_32px',
      'agl_icon_dig_solar_bundle_32px',
      'agl_icon_dig_solar_no_32px',
      'agl_icon_dig_solar_yes_32px',
      'agl_icon_dig_voip_no_32px',
      'agl_icon_dig_voip_yes_32px',
      'agl_icon_dig_access_no_32px',
      'agl_icon_dig_cross_32px',
      'agl_icon_dig_fix_32px',
      'agl_icon_dig_fix_no_32px',
      'agl_icon_dig_inspect_no_32px',
      'agl_icon_dig_lights_normal_32px',
      'agl_icon_dig_lights_red_32px',
      'agl_icon_dig_lights_screen_error_32px',
      'agl_icon_dig_service_32px',
      'agl_icon_dig_service_no_32px',
      'agl_icon_dig_solar_32px',
      'agl_icon_dig_solar_damage_32px',
      'agl_icon_dig_solar_dirty_32px',
      'agl_icon_dig_solar_shaded_32px',
      'agl_icon_dig_switch_off_32px',
      'agl_icon_dig_switch_on_32px',
      'agl_icon_dig_tick_in_circle_32px',
      'agl_icon_dig_usage_high_32px',
      'agl_icon_dig_bill_no',
      'agl_icon_dig_bill_yes',
      'agl_icon_dig_business',
      'agl_icon_dig_connection_connected',
      'agl_icon_dig_connection_new',
      'agl_icon_dig_support_32px',
      'agl_icon_dig_clock_32px',
      'agl_icon_dig_calendar_32px',
      'agl_icon_dig_bell_48px',
      'agl_icon_dig_user_32px'
    ];
    this.hasPanel = false;
    this.overflowSet = false;
  }
  // propagate value change from model to view
  valueChange() {
    if (this.inputElement) {
      this.inputElement.checked = this.checked;
    }
    if (this.type === 'panel') {
      this.setPanelVisibility(this.inputElement);
    }
  }
  componentWillLoad() {
    var _a;
    const illegalDivTags = document.querySelectorAll('.radio-wrapper label div');
    if (illegalDivTags.length > 0) {
      throw new Error('To be semantically correct, the slot can not contain a div tag');
    }
    if (this.bottomMargin && this.type !== 'panel') {
      throw new Error('The bottomMargin prop is only valid with the RadioButtonType.panel type');
    }
    if (!this.radioButtonTypes.includes(this.type)) {
      throw new Error(this.type + ' is not a valid radio button type');
    }
    if (this.type === 'image' && this.size == 'small') {
      throw new Error(this.size + ' is not a valid size for the image radio button type');
    }
    if (!['large', 'small'].includes(this.size)) {
      throw new Error(this.size + ' is not a valid radio button size');
    }
    if (this.type === 'panel' && !this.bottomMargin) {
      this.bottomMargin = 'space03';
    }
    this.hasPanel = !!this.host.querySelector('[slot="panel"]');
    if (((_a = this.host) === null || _a === void 0 ? void 0 : _a.children.length) > 0) {
      // content radio button type is slatted to be deprecated. so it allows a range of tags for the moment
      if (this.type === 'content') {
        checkSlottedContentForInvalidHTML(this.host, ['agl-ds-radio-button', 'agl-ds-text', 'img', 'span', 'hr', 'br', 'p']);
      }
      else if (this.type !== 'panel') {
        checkSlottedContentForInvalidHTML(this.host, ['agl-ds-radio-button', 'agl-ds-text']);
      }
    }
  }
  componentDidLoad() {
    hideFocusRingWhenUsingMouse(this.inputElement);
  }
  // propagate value change from view to model
  inputChanged(ev) {
    const eventTarget = ev.target;
    this.dsCheckedChange.emit(eventTarget);
    if (this.type === 'panel') {
      this.setPanelVisibility(ev.target);
    }
  }
  getIcon() {
    switch (this.type) {
      case 'agl_icon_dig_account_no_32px':
        return accountNo;
      case 'agl_icon_dig_account_yes_32px':
        return accountYes;
      case 'agl_icon_dig_battery_32px':
        return batteryIcon;
      case 'agl_icon_dig_battery_new_32px':
        return batteryNew;
      case 'agl_icon_dig_calendar_48px':
        return calendar;
      case 'agl_icon_dig_calendar_dollar_48px':
        return calendarDollar;
      case 'agl_icon_carbon_neutral_off_32px':
        return carbonNeutralOff;
      case 'agl_icon_carbon_neutral_on_32px':
        return carbonNeutralOn;
      case 'agl_icon_dig_heart_32px':
        return heartIcon;
      case 'agl_icon_dig_home_32px':
        return homeIcon;
      case 'agl_icon_dig_internet_32px':
        return internetIcon;
      case 'agl_icon_dig_internet_no_32px':
        return noInternetIcon;
      case 'agl_icon_dig_life_support_32px':
        return lifeSupportIcon;
      case 'agl_icon_dig_listing_no_32px':
        return nolistIcon;
      case 'agl_icon_dig_medical_alarm_32px':
        return medicalAlarm;
      case 'agl_icon_dig_modem_32px':
        return modemIcon;
      case 'agl_icon_dig_modem_use_own_32px':
        return modemUseOwnIcon;
      case 'agl_icon_dig_moving_32px':
        return movingIcon;
      case 'agl_icon_dig_pencil_32px':
        return pencilIcon;
      case 'agl_icon_dig_plan_add_32px':
        return planAddIcon;
      case 'agl_icon_dig_plan_edit_32px':
        return planEditIcon;
      case 'agl_icon_dig_question_32px':
        return questionIcon;
      case 'agl_icon_dig_rent_32px':
        return rentIcon;
      case 'agl_icon_dig_solar_bundle_32px':
        return solarBundle;
      case 'agl_icon_dig_solar_no_32px':
        return solarNo;
      case 'agl_icon_dig_solar_yes_32px':
        return solarYes;
      case 'agl_icon_dig_voip_no_32px':
        return voipNo;
      case 'agl_icon_dig_voip_yes_32px':
        return voipYes;
      case 'agl_icon_dig_access_no_32px':
        return accessNo;
      case 'agl_icon_dig_cross_32px':
        return cross;
      case 'agl_icon_dig_fix_32px':
        return fix;
      case 'agl_icon_dig_fix_no_32px':
        return fixNo;
      case 'agl_icon_dig_inspect_no_32px':
        return inspectNo;
      case 'agl_icon_dig_lights_normal_32px':
        return lightsNormal;
      case 'agl_icon_dig_lights_red_32px':
        return lightsRed;
      case 'agl_icon_dig_lights_screen_error_32px':
        return lightsScreenError;
      case 'agl_icon_dig_service_32px':
        return service;
      case 'agl_icon_dig_service_no_32px':
        return serviceNo;
      case 'agl_icon_dig_solar_32px':
        return solar;
      case 'agl_icon_dig_solar_damage_32px':
        return solarDamage;
      case 'agl_icon_dig_solar_dirty_32px':
        return solarDirty;
      case 'agl_icon_dig_solar_shaded_32px':
        return solarShaded;
      case 'agl_icon_dig_switch_off_32px':
        return switchOff;
      case 'agl_icon_dig_switch_on_32px':
        return switchOn;
      case 'agl_icon_dig_tick_in_circle_32px':
        return tickInCircle;
      case 'agl_icon_dig_usage_high_32px':
        return usageHigh;
      case 'agl_icon_dig_bill_no':
        return billNo;
      case 'agl_icon_dig_bill_yes':
        return billYes;
      case 'agl_icon_dig_business':
        return business;
      case 'agl_icon_dig_connection_connected':
        return connected;
      case 'agl_icon_dig_connection_new':
        return newConnection;
      case 'agl_icon_dig_support_32px':
        return supportIcon;
      case 'agl_icon_dig_calendar_32px':
        return calendarIcon;
      case 'agl_icon_dig_clock_32px':
        return clockIcon;
      case 'agl_icon_dig_bell_48px':
        return bellIcon;
      case 'agl_icon_dig_user_32px':
        return user;
      default:
        throw new Error(this.type + ' is not a valid radio button type');
    }
  }
  setPanelVisibility(srcElement) {
    const srcElementParent = srcElement.parentElement;
    srcElementParent.lastElementChild.style.overflow = '';
    this.overflowSet = false;
    // make the panels not visible to stop the user being able to tab to the elements in the hidden panel
    if (this.panel) {
      const panels = document.querySelectorAll(`[data-group-name="${this.groupName}"]  .expand-panel`);
      if (panels.length > 0) {
        panels.forEach((panel) => {
          panel.classList.add('not-visible');
        });
        this.panel.classList.remove('not-visible');
      }
    }
  }
  setPanelOverflowVisible() {
    if (!this.overflowSet) {
      this.overflowSet = true;
      //need to give the animation time to finish, otherwise the panel could show over the top of other panel radio buttons
      setTimeout(() => {
        this.panel.style.overflow = 'visible';
      }, 800);
    }
  }
  renderInput(id) {
    let attributes = {};
    if (this.type === 'panel' && this.hasPanel) {
      attributes = { 'aria-describedby': 'panel-' + id, 'aria-controls': 'panel-' + id };
    }
    return (h("input", Object.assign({ type: "radio", ref: (l) => (this.inputElement = l), id: id, name: this.groupName, checked: this.checked, value: this.value, onChange: (event) => this.inputChanged(event) }, attributes)));
  }
  render() {
    const id = generateRandomNumber();
    if (this.type === 'basic') {
      return (h(Host, null,
        h("div", { class: "radio-wrapper basic-radio" },
          this.renderInput(id),
          h("label", { htmlFor: id },
            h("slot", null)))));
    }
    else if (this.type === 'panel') {
      return (h(Host, null,
        h("div", { class: "radio-wrapper panel-radio", "data-group-name": this.groupName },
          this.renderInput(id),
          h("label", { htmlFor: id },
            h("slot", { name: "heading" })),
          this.hasPanel ? (h("div", { id: 'panel-' + id, class: "expand-panel not-visible", "tab-index": "0", ref: (l) => (this.panel = l), onMouseOver: () => this.setPanelOverflowVisible() },
            h("div", { class: {
                ['expand-panel__inner']: true,
                ['agl-ds--bottom-margin-' + this.bottomMargin]: true
              } },
              h("slot", { name: "panel" })))) : (''))));
    }
    else if (this.type.indexOf('icon') >= 0) {
      return (h(Host, null,
        h("div", { class: "radio-wrapper icon-or-image-radio" },
          this.renderInput(id),
          h("label", { htmlFor: id, class: this.size + '-icon-radio-button' },
            h("agl-ds-icon", { class: "tick", icon: tick, size: "xs" }),
            h("span", { class: this.size + '-svg', innerHTML: this.getIcon() }),
            h("slot", null)))));
    }
    else if (this.type === 'image') {
      return (h(Host, null,
        h("div", { class: "radio-wrapper icon-or-image-radio" },
          this.renderInput(id),
          h("label", { htmlFor: id },
            h("agl-ds-icon", { class: "tick", icon: tick, size: "xs" }),
            h("img", { class: "icon-or-image-radio__image", "aria-hidden": "true", src: this.imagePath }),
            h("slot", null)))));
    }
    else if (this.type === 'content') {
      return (h(Host, null,
        h("div", { class: "radio-wrapper content-radio" },
          this.renderInput(id),
          h("label", { htmlFor: id },
            h("agl-ds-icon", { class: "tick", icon: tick, size: "xs" }),
            h("slot", null)))));
    }
  }
  static get is() { return "agl-ds-radio-button"; }
  static get originalStyleUrls() { return {
    "$": ["radio-button.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["radio-button.component.css"]
  }; }
  static get properties() { return {
    "groupName": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The group name for the radio button"
      },
      "attribute": "group-name",
      "reflect": false
    },
    "value": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The value for the radio button"
      },
      "attribute": "value",
      "reflect": false
    },
    "type": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "RadioButtonType",
        "resolved": "\"basic\" | \"panel\" | \"content\" | \"image\" | \"agl_icon_carbon_neutral_off_32px\" | \"agl_icon_carbon_neutral_on_32px\" | \"agl_icon_dig_account_no_32px\" | \"agl_icon_dig_account_yes_32px\" | \"agl_icon_dig_battery_32px\" | \"agl_icon_dig_battery_new_32px\" | \"agl_icon_dig_calendar_48px\" | \"agl_icon_dig_calendar_dollar_48px\" | \"agl_icon_dig_heart_32px\" | \"agl_icon_dig_home_32px\" | \"agl_icon_dig_internet_32px\" | \"agl_icon_dig_internet_no_32px\" | \"agl_icon_dig_life_support_32px\" | \"agl_icon_dig_listing_no_32px\" | \"agl_icon_dig_medical_alarm_32px\" | \"agl_icon_dig_modem_32px\" | \"agl_icon_dig_modem_use_own_32px\" | \"agl_icon_dig_moving_32px\" | \"agl_icon_dig_pencil_32px\" | \"agl_icon_dig_plan_add_32px\" | \"agl_icon_dig_plan_edit_32px\" | \"agl_icon_dig_question_32px\" | \"agl_icon_dig_rent_32px\" | \"agl_icon_dig_solar_bundle_32px\" | \"agl_icon_dig_solar_no_32px\" | \"agl_icon_dig_solar_yes_32px\" | \"agl_icon_dig_voip_no_32px\" | \"agl_icon_dig_voip_yes_32px\" | \"agl_icon_dig_access_no_32px\" | \"agl_icon_dig_cross_32px\" | \"agl_icon_dig_fix_32px\" | \"agl_icon_dig_fix_no_32px\" | \"agl_icon_dig_inspect_no_32px\" | \"agl_icon_dig_lights_normal_32px\" | \"agl_icon_dig_lights_red_32px\" | \"agl_icon_dig_lights_screen_error_32px\" | \"agl_icon_dig_service_32px\" | \"agl_icon_dig_service_no_32px\" | \"agl_icon_dig_solar_32px\" | \"agl_icon_dig_solar_damage_32px\" | \"agl_icon_dig_solar_dirty_32px\" | \"agl_icon_dig_solar_shaded_32px\" | \"agl_icon_dig_switch_off_32px\" | \"agl_icon_dig_switch_on_32px\" | \"agl_icon_dig_tick_in_circle_32px\" | \"agl_icon_dig_usage_high_32px\" | \"agl_icon_dig_bill_no\" | \"agl_icon_dig_bill_yes\" | \"agl_icon_dig_business\" | \"agl_icon_dig_connection_connected\" | \"agl_icon_dig_connection_new\" | \"agl_icon_dig_support_32px\" | \"agl_icon_dig_clock_32px\" | \"agl_icon_dig_calendar_32px\" | \"agl_icon_dig_bell_48px\" | \"agl_icon_dig_user_32px\"",
        "references": {
          "RadioButtonType": {
            "location": "import",
            "path": "../common/radio-button.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The type of radio button to be displayed"
      },
      "attribute": "type",
      "reflect": true,
      "defaultValue": "'basic'"
    },
    "size": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "Size",
        "resolved": "\"large\" | \"small\"",
        "references": {
          "Size": {
            "location": "import",
            "path": "../common/radio-button.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The type of radio button to be displayed"
      },
      "attribute": "size",
      "reflect": false,
      "defaultValue": "'large'"
    },
    "checked": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Is the radio button in a checked state or not when first displayed."
      },
      "attribute": "checked",
      "reflect": false,
      "defaultValue": "false"
    },
    "bottomMargin": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "BottomMargin",
        "resolved": "\"none\" | \"space01\" | \"space02\" | \"space03\"",
        "references": {
          "BottomMargin": {
            "location": "import",
            "path": "../common/radio-button.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride bottom margin size of the radio button panel"
      },
      "attribute": "bottom-margin",
      "reflect": false
    },
    "imagePath": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The path of the image to be displayed on the image type radio button. Note this image is set at 96px x 128px and its the responsibility of UX to provide an image with the correct 4:3 ratio.\nRadio buttons with a total button count not equal to 2 or 4 on mobile and desktop will have cropped images 96px x 96px."
      },
      "attribute": "image-path",
      "reflect": false
    }
  }; }
  static get events() { return [{
      "method": "dsCheckedChange",
      "name": "dsCheckedChange",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Radio button changed event (DO NOT USE THIS EVENT IN A SYSTEM THAT USES THE DESIGN LIBRARY) - this is accessed by the radio button group component"
      },
      "complexType": {
        "original": "CustomEvent",
        "resolved": "CustomEvent<any>",
        "references": {
          "CustomEvent": {
            "location": "global"
          }
        }
      }
    }]; }
  static get elementRef() { return "host"; }
  static get watchers() { return [{
      "propName": "checked",
      "methodName": "valueChange"
    }]; }
}
